export default {
	loader: false,
	llave: '',
	server_url: "http://localhost:8000/api/",
	uuid: ''
}